import { render, staticRenderFns } from "./project-member-new.vue?vue&type=template&id=3f817d74&scoped=true"
import script from "./project-member-new.vue?vue&type=script&lang=ts"
export * from "./project-member-new.vue?vue&type=script&lang=ts"
import style0 from "./project-member-new.vue?vue&type=style&index=0&id=3f817d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f817d74",
  null
  
)

export default component.exports